const actions = {
  PROGRESS_ADD_BEGIN: 'PROGRESS_ADD_BEGIN',
  PROGRESS_ADD_SUCCESS: 'PROGRESS_ADD_SUCCESS',
  PROGRESS_ADD_ERR: 'PROGRESS_ADD_ERR',

  PROGRESS_COMMENT_ADD_BEGIN: 'PROGRESS_COMMENT_ADD_BEGIN',
  PROGRESS_COMMENT_ADD_SUCCESS: 'PROGRESS_COMMENT_ADD_SUCCESS',
  PROGRESS_COMMENT_ADD_ERR: 'PROGRESS_COMMENT_ADD_ERR',
  
  GET_PROGRESS_BY_TASK_READ_BEGIN: 'GET_PROGRESS_BY_TASK_READ_BEGIN',
  GET_PROGRESS_BY_TASK_READ_SUCCESS: 'GET_PROGRESS_BY_TASK_READ_SUCCESS',
  GET_PROGRESS_BY_TASK_READ_ERR: 'GET_PROGRESS_BY_TASK_READ_ERR',
  
  TODAY_PROGRESS_READ_BEGIN: 'TODAY_PROGRESS_READ_BEGIN',
  TODAY_PROGRESS_READ_SUCCESS: 'TODAY_PROGRESS_READ_SUCCESS',
  TODAY_PROGRESS_READ_ERR: 'TODAY_PROGRESS_READ_ERR',

  todayProgressReadBegin: () => {
    return {
      type: actions.TODAY_PROGRESS_READ_BEGIN,
    };
  },
  
  todayProgressReadSuccess: (data) => {
    return {
      type: actions.TODAY_PROGRESS_READ_SUCCESS,
      data,
    };
  },

  todayProgressReadErr: (err) => {
    return {
      type: actions.TODAY_PROGRESS_READ_ERR,
      err,
    };
  },

  progressCommentAddBegin: () => {
    return {
      type: actions.PROGRESS_COMMENT_ADD_BEGIN,
    };
  },

  progressCommentAddSuccess: (data) => {
    return {
      type: actions.PROGRESS_COMMENT_ADD_SUCCESS,
      data,
    };
  },

  progressCommentAddErr: (err) => {
    return {
      type: actions.PROGRESS_COMMENT_ADD_ERR,
      err,
    };
  },

  progressAddBegin: () => {
    return {
      type: actions.PROGRESS_ADD_BEGIN,
    };
  },

  progressAddSuccess: (data) => {
    return {
      type: actions.PROGRESS_ADD_SUCCESS,
      data,
    };
  },

  progressAddErr: (err) => {
    return {
      type: actions.PROGRESS_ADD_ERR,
      err,
    };
  },

  getProgressByTaskReadBegin: () => {
    return {
      type: actions.GET_PROGRESS_BY_TASK_READ_BEGIN,
    };
  },

  getProgressByTaskReadSuccess: (data) => {
    return {
      type: actions.GET_PROGRESS_BY_TASK_READ_SUCCESS,
      data,
    };
  },

  getProgressByTaskReadErr: (err) => {
    return {
      type: actions.GET_PROGRESS_BY_TASK_READ_ERR,
      err,
    };
  },      
};

export default actions;
